import React, { useState } from 'react';
import { Flex, Space, Text } from '@bb/elements-web';
import { ReadFilled } from '@ant-design/icons';
import { Button } from 'components';
import {
  CardAvatar,
  CardHeader,
  CardProgress,
  CenterTextWrapper,
} from '@brokerbay/design-components';
import {
  MarketingBadgeApple,
  MarketingBadgeGoogle,
} from 'components/MarketingBadges';
import { message } from 'antd';
import { useUserOnboardingContext } from '../../contexts/UserOnboardingContext';

export const LinkToAppView = () => {
  const [url, setUrl] = useState<string>('#');
  const userOnboardingContext = useUserOnboardingContext();

  React.useEffect(() => {
    message.success('Account created');
    (async () => {
      const onboardingUrl =
        await userOnboardingContext!.completeOnboardingUrl();
      setUrl(onboardingUrl);
    })();
  }, []);

  return (
    <Space direction="vertical" size={16}>
      <CardHeader
        title="Download and install the app"
        icon={<CardAvatar icon={ReadFilled} />}
      />

      <CenterTextWrapper>
        <Text>
          Want everything at your fingertips? Download the app by searching
          &apos;BrokerBay&apos; or &apos;Supra&apos; or use one of the links
          below.
        </Text>
      </CenterTextWrapper>

      <Flex gap={16} align="center" justify="center">
        <MarketingBadgeApple />
        <MarketingBadgeGoogle />
      </Flex>

      <Button type="primary" block data-cy="button-login" href={url}>
        Go to Dashboard
      </Button>

      <CardProgress percent={(5 / 5) * 100} />
    </Space>
  );
};
